import { ChangeEvent, forwardRef, HTMLProps, Fragment } from 'react';
import classnames from 'classnames';

import FontIcon from 'components/icons';

import './styles/input.scss';
import './styles/checkbox.scss';

type Props = Omit<HTMLProps<HTMLInputElement>, 'id' | 'onChange' | 'value' | 'as'> & {
  checked?: boolean,
  hasError?: boolean,
  icon?: string,
  id: string,
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
  value?: string | number
}

const InputField = forwardRef<HTMLInputElement, Props>(
  function InputField(props, ref:any) {
    const { className, checked, hasError, icon, type, ...rest } = props;
    const checkbox = type === 'checkbox';

    return (
      <Fragment>
        <input
          { ...rest }
          ref={ ref }
          className={ classnames(
            { 'form-field--checkbox': checkbox },
            { 'form-field--input input': !checkbox },
            { 'input-has-error': !!hasError },
            className) }
          type={ type ?? 'text' }
          checked={ checked }
        />
        {icon && (<span className="icon is-small is-left inputIcons"><FontIcon icon={ icon } /></span>)}
      </Fragment>
    );
  }
);

export default InputField;
